export default `.ids-expandable-area {
  border-bottom: var(--ids-expandable-area-border-bottom);
  padding: calc(var(--ids-space-xs) * 3) var(--ids-space-none);
}
.ids-expandable-area .expandable-pane-content {
  margin-block-start: calc(var(--ids-space-xs) * 2);
}

:host([no-padding]) .ids-expandable-area {
  padding: 0;
  border-bottom: none;
}

:host([type=toggle-btn]) .ids-expandable-area-header {
  margin-block-end: var(--ids-space-xs);
}

:host([type=partial]) .ids-expandable-area-visible-pane .expandable-pane-content {
  margin-block-start: calc(var(--ids-space-xs) * 3);
}
:host([type=partial]) .ids-expandable-area-pane .expandable-pane-content {
  margin-block-start: var(--ids-space-none);
}

.ids-expandable-area-header ::slotted(ids-text) {
  display: block;
  margin-block-end: var(--ids-space-xs);
}

.ids-expandable-area-footer ::slotted(ids-hyperlink),
.ids-expandable-area-footer ::slotted(ids-text) {
  display: block;
  margin-block-start: var(--ids-space-none);
  margin-block-end: calc(var(--ids-space-xs) * -1);
}

[data-expander=link] {
  display: inline-block;
}
[data-expander=link][aria-expanded=true] {
  margin-block-start: var(--ids-space-xs);
}

[data-expander=header] {
  pointer-events: none;
}

[data-expander=header] [name=header] {
  pointer-events: initial;
}

.ids-expandable-area-pane {
  height: var(--ids-space-none);
  overflow: hidden;
  transition: height var(--ids-motion-duration) var(--ids-motion-linear);
}

:host(.ids-date-picker-expandable) .ids-expandable-area .ids-expandable-area-pane {
  transition: height var(--ids-motion-datepicker-duration) var(--ids-motion-linear);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
